// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._42cYW7eN>*+*{margin-top:1.5rem}.\\+gowHOew{align-items:center;border:1.5px solid var(--color-primary);border-radius:1rem;color:var(--color-primary);display:inline-flex;font-size:.88rem;font-weight:500;gap:.75rem;justify-content:center;line-height:1.25rem;margin-top:1rem;padding:.5rem .75rem;transition:.1s linear;transition-property:opacity}@media(hover:hover){.\\+gowHOew:hover{opacity:.8}}@media(hover:none){.\\+gowHOew:active{opacity:.8}}.Y-YH0v2v{color:var(--color-fg);font-size:max(2rem,min(4.84vw,5.81rem));font-weight:700;line-height:1;padding:1.5rem 0;text-transform:uppercase}.VYM-Kkbg{display:grid;grid-auto-rows:1fr;grid-template-columns:repeat(3,minmax(0,1fr));grid-gap:1rem;gap:1rem}@media(max-width:1023.98px){.VYM-Kkbg{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:667.98px){.VYM-Kkbg{align-items:start;grid-auto-rows:min-content;grid-template-columns:minmax(0,1fr)}}.tFMl7m\\+U{color:var(--color-fg);font-size:1rem;padding:1.5rem 0}.D-R09gdv{min-height:30.38rem}@media(max-width:667.98px){.D-R09gdv{min-height:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "_42cYW7eN",
	"back": "+gowHOew",
	"title": "Y-YH0v2v",
	"cards": "VYM-Kkbg",
	"empty": "tFMl7m+U",
	"card": "D-R09gdv"
};
module.exports = ___CSS_LOADER_EXPORT___;
